import { render, staticRenderFns } from "./OffersView.vue?vue&type=template&id=9fc25f5c&scoped=true&"
import script from "./OffersView.vue?vue&type=script&lang=js&"
export * from "./OffersView.vue?vue&type=script&lang=js&"
import style0 from "./OffersView.vue?vue&type=style&index=0&id=9fc25f5c&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9fc25f5c",
  null
  
)

export default component.exports